module.exports = __webpack_public_path__ + "media/images/content-for-photography-3aa323c5.jpg";